module.exports = __webpack_public_path__ + "assets/python.cca2e4ec.svg";